import { FormattedMessage } from 'react-intl'
import { Grid, Typography } from '@mui/material'
import InputField from 'components/form/InputField'
import SwitchToggle from 'components/form/SwitchToggle'
import FormSectionContainer from 'components/layout/FormSectionContainer'
import { UseFormReturn } from 'react-hook-form'
import RichTextEditor from '../RichTextEditor'
import styled from 'styled-components'

interface Props {
  form: UseFormReturn<any>
}

export default function ChallengeFormPhase3({ form }: Props): JSX.Element {
  const { register, control, watch } = form

  return (
    <>
      <FormSectionContainer>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <h2>
              <FormattedMessage id="challenges.descriptions" />
            </h2>
          </Grid>
          <Grid item xs={6}>
            <StyledInputField
              disabled={form.formState.disabled}
              register={register}
              watch={watch}
              name="info.subtitle.content"
              type="text"
              label={<FormattedMessage id="challenges.subtitle" />}
              outlined
              maxCharactersSoftLimit={80}
              maxLength={80}
              required
              placeholder="Required"
            />
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <RichTextEditor
              disabled={form.formState.disabled}
              name="info.longDescription.content"
              control={control}
              label={<FormattedMessage id="challenges.challengeDescription" />}
              placeholder={'Required'}
              readMoreAtCharacter={210}
              maxCharactersSoftLimit={3500}
              minHeight="420px"
              maxHeight="420px"
              required
            />
          </Grid>
          <Grid item xs={6}>
            <RichTextEditor
              name="info.additionalInformation.content"
              control={control}
              label={<FormattedMessage id="challenges.additionalInfo" />}
              placeholder={'Required'}
              maxCharactersSoftLimit={3500}
              minHeight="420px"
              maxHeight="420px"
              required
              disabled={form.formState.disabled}
            />
          </Grid>
        </Grid>
      </FormSectionContainer>

      <FormSectionContainer>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <h2>
              <FormattedMessage id="strings.prizes" />
            </h2>
            <Grid sx={{ display: 'flex', flexDirection: 'column', marginTop: '24px', width: '50%' }}>
              <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Typography sx={{ color: '373D40', fontSize: '14px', fontWeight: '500' }}>
                  Challenge has prizes
                </Typography>
                <SwitchToggle
                  disabled={form.formState.disabled}
                  control={control}
                  name="prizeInfo.hasPrizes"
                  labelPlacement="start"
                  value={watch('prizeInfo.hasPrizes')}
                />
              </Grid>
              <Typography sx={{ color: '#8A8A8E' }}>
                Let participants know what's at stake by adding info about the prizes.
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <InputField
              register={register}
              watch={watch}
              name="prizeInfo.shortDescription.content"
              type="text"
              label={<FormattedMessage id="challenges.prizeText" />}
              outlined
              maxCharactersSoftLimit={200}
              disabled={!watch('prizeInfo.hasPrizes') || form.formState.disabled}
              maxLength={200}
              required={watch('prizeInfo.hasPrizes')}
            />
            <RichTextEditor
              name="prizeInfo.longDescription.content"
              control={control}
              label={<FormattedMessage id="challenges.prizeInfoText" />}
              maxCharactersSoftLimit={2000}
              disabled={!watch('prizeInfo.hasPrizes') || form.formState.disabled}
              required={watch('prizeInfo.hasPrizes')}
              placeholder="Required"
            />
          </Grid>
        </Grid>
      </FormSectionContainer>
    </>
  )
}

const StyledInputField = styled(InputField)`
  & .MuiOutlinedInput-root {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    & fieldset {
      border-color: #e4e4e7;
    }

    &:hover fieldset {
      border-color: #e4e4e7;
    }

    &.Mui-focused fieldset {
      border-color: #e4e4e7;
    }
  }

  & .MuiOutlinedInput-input {
    padding: 10px 12px;
  }

  & .MuiSelect-icon {
    color: #8a8a8e;
    font-size: 20px;
  }
`
